/* eslint-disable no-loop-func */

/* eslint-disable no-cond-assign */
import classNames from '@jd/jmtd-tools/es/classnames';
import { bindEvent } from '@jd/jmtd-tools/es/element';
import { getValue } from '../tools/util';
var sTriggerNode = Symbol('triggerNode');
export default function BasicPopover(_ref, _ref2) {
  var setOpen = _ref.setOpen,
      open = _ref.open;
  var className = _ref2.className,
      children = _ref2.children,
      popover = _ref2.popover,
      trigger = _ref2.trigger,
      mouseEnterDelay = _ref2.mouseEnterDelay,
      mouseLeaveDelay = _ref2.mouseLeaveDelay,
      exclusive = _ref2.exclusive,
      _ref2$componentDidOpe = _ref2.componentDidOpen,
      componentDidOpen = _ref2$componentDidOpe === void 0 ? function () {} : _ref2$componentDidOpe,
      _ref2$onClose = _ref2.onClose,
      onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose;
  var isHover = trigger === 'hover';
  var isClick = trigger === 'click';
  return {
    onClose: onClose,
    exclusive: exclusive !== null && exclusive !== void 0 ? exclusive : isClick,
    popoverProps: {
      onMouseEnter: function onMouseEnter() {
        if (isHover) {
          setOpen(true);
        }
      },
      onMouseLeave: function onMouseLeave() {
        if (isHover) {
          setOpen(false);
        }
      }
    },
    className: classNames('jmtd-popover-basic', className),
    children: children,
    popover: getValue(popover, {
      setOpen: setOpen,
      open: open
    }),
    style: isHover ? {
      transitionDelay: "".concat((open ? mouseEnterDelay : mouseLeaveDelay) / 1000, "s")
    } : {},
    onUpdate: function onUpdate(_ref3) {
      var triggerNode = _ref3.triggerNode,
          state = _ref3.state,
          self = _ref3.self;

      if (state[sTriggerNode] !== triggerNode) {
        state[sTriggerNode] = triggerNode;

        if (isHover) {
          bindEvent(triggerNode, 'mouseover', function () {
            setOpen(true);
          });
          bindEvent(triggerNode, 'mouseout', function () {
            setOpen(false);
          });
        } else if (isClick) {
          bindEvent(triggerNode, 'click', function () {
            setOpen(!self.open);
          });
        }
      }
    },
    onUpdateOpen: componentDidOpen
  };
}